import React, { useEffect, useRef } from 'react';
import { Box, Button, CircularProgress, Container } from '@mui/material';
import HeaderSection from './studentImpactReport/HeaderSection';
import StudentDetails from './studentImpactReport/StudentDetails';
import ExamTable from './studentImpactReport/ExamTable';
import PerformanceSection from './studentImpactReport/PerfomanceSection';
import CriteriaDefinitions from './studentImpactReport/CriteriaDefinitions';
import { useReactToPrint } from 'react-to-print';
import CertificateGenerator from '../../../cro/myworkspace/Dashboard/CertificateGenerator';
import FooterSection from './studentImpactReport/FooterSection';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { useDispatch } from 'react-redux';
import { getImpactReportDetials, updateImpactReportDownload } from '../../../../redux/features/crmSlice';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import NoDataFound from '../../../../components/NodataIndication/NoDataFound';

export default function ImpactReport() {
  const { id } = useParams();

  const { impactReportDetails, loading } = useSelector((state) => state.crm);

  const reportRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getImpactReportDetials(id));
  }, []);

  const reactToPrintFn = useReactToPrint({
    content: () => reportRef.current,
    onAfterPrint: () => dispatch(updateImpactReportDownload(id)),
  });

  return (
    <GlobalWrapper title={'Impact Report'}>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      ) : impactReportDetails ? (
        <Container>
          <Box ref={reportRef}>
            <HeaderSection />
            <Box>
              <StudentDetails student={impactReportDetails} />
              <ExamTable subjects={impactReportDetails?.subjects} />
              <PerformanceSection performance={impactReportDetails} />
              <CriteriaDefinitions />
            </Box>
            {/* ))} */}
            <CertificateGenerator noDownload name={impactReportDetails?.student_name} />
            <FooterSection />
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button variant="contained" color="success" onClick={reactToPrintFn}>
              Download Impact Report
            </Button>
          </Box>
        </Container>
      ) : (
        <NoDataFound />
      )}
    </GlobalWrapper>
  );
}
